import { IsNotEmpty } from "class-validator";

export class EmailVerificationDto {
  //
  @IsNotEmpty()
  email_verification_code: string;
}
